export enum MESSAGE_TYPES {
	SCROLL = 'scroll',
	INIT = 'init',
	ENTRY = 'client-data-send',
}
